
<template>
  <el-dialog
    title="选择产品"
    width="520px"
    :visible.sync="dialogProduct.isShow"
    append-to-body
  >
    <el-form :inline="true" @submit.native.prevent>      
      <el-form-item >
        <el-input  placeholder="产品名称" v-model="name"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" v-on:click="Search" >查询</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="rows" style="width: 100%">
      <el-table-column  prop="Barcode" fixed="left" label="编码"> </el-table-column>
      <el-table-column  prop="Name" label="名称" :show-overflow-tooltip="true"> </el-table-column>
      <el-table-column  prop="Price" label="价格"> </el-table-column>
      <el-table-column  prop="VipPrice" label="会员价"> </el-table-column>
      <el-table-column  prop="BusinessName" :show-overflow-tooltip="true" label="所属商家"> </el-table-column>
      <el-table-column  prop="CategoryName" :show-overflow-tooltip="true" label="类别"> </el-table-column>
      <el-table-column  fixed="right" label="操作" width="120">
        <template slot-scope="scope">
          <el-button @click.native.prevent="SelectProduct(scope.row)" type="text" size="small">
            选择
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      small
      @current-change="handleCurrentChange"
      layout="prev, pager, next"
      :page-size="5"
      :total="totalCount">
    </el-pagination>
  </el-dialog>
</template>

<script  type='text/ecmascript-6'>
  export default {
    props:{
      dialogProduct:{        
      }
    },
    data(){
      return {
      name:'',
      pageIndex:1,
      pagesize:5,
      totalCount:0,
      sort:' sort asc',
      rows:[],
      loading:false,
      form:{}
      }
    },
    computed:{
    },
    mounted(){
      this.GetData();
    },
    methods:{     
      Search:function(){
        this.pageIndex = 1;
        this.GetData();
      },
      GetData:function(){
        var that = this
        this.axios({
          method:'get',
          url:that.global.serverSrc + '/api/Product/Index',
          params:{
            name : that.name,
            pageIndex : that.pageIndex,
            pagesize : that.pagesize,
            sort : that.sort
          }
        }).then(function (resp) {
          that.totalCount = resp.data.totalCount
          that.rows = resp.data.products
        }).catch(resp => {
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      },
      SelectProduct(row){ 
        this.$emit('UpdateProduct',row.Id,row.Name)
        this.dialogProduct.isShow = false
      },      
      handleCurrentChange(val) {
        this.pageIndex = val 
        this.GetData()
      },
    },
    components:{    
       
    },
    created(){
    
    },
  }
</script>
<style lang='stylus' rel='stylesheet/stylus'>
.content-header
  padding 24px
  border 1px solid #C0C4CC
.content-main
  padding 24px  
</style>